import React from "react";
import ProjectCard from "../ProjectCard/ProjectCard";
import ProjectCard2 from "../ProjectCard2/ProjectCard2";
import "./Projects.css";

/* https://i.ibb.co/yNF1gsG/Screenshot-15.png
https://i.ibb.co/XSD9CDy/Screenshot-13.png
https://i.ibb.co/XSD9CDy/Screenshot-13.png */

const projects = [
  {
    id: 1,
    projectName: "Rokomari.com",
    summary:
      "Rokomari operates as a marketplace. It works with publishers who sell their books on this platform. It does not publish any of the books it sells. Most of the books in available in this marketplace are written in Bengali and English, and a small number of books of other languages can be found here. ",
    technology: "HTML, CSS JSP, Angular",
    duration: "Continous",
    live: "https://rokomari.com/",
    img: [
      "https://bangladeshbusinessdir.com/wp-content/uploads/2015/06/rokomari-com2.jpg",
      "https://i.ytimg.com/vi/6pydI2jqUZM/maxresdefault.jpg",
      "https://i.pinimg.com/736x/45/a8/11/45a81160cb4e6048ced0270a52414406.jpg",

      "https://i.pinimg.com/736x/45/a8/11/45a81160cb4e6048ced0270a52414406.jpg",
    ],
    points: [
      "One of the Largest E-commerece company in the Bangladesh",
      "It has 8 sister companies",
      "A vast database with all kind of IT related works",
      "30+ team members in Software team and total 200+ employess",
      "Working in maintaining this large system",
      "Change or add new feature on demand",
      "Track the users need and update accordingly",
      "Working in a team in gitlab.",
      "Working as a manager in front end team",
      "A large number of features and new system are coming everyday work on them",
    ],
  },
  {
    id: 2,
    projectName: "Rokomari Affiliate",
    summary:
      "An affiliate service for one of the largest E-commerce company of Bangladesh. Where the web app is working with 3.5 millions of products and thousands a=of affiliate. An affiliate can copy any link, and share in his social media. If any one buys any product with the given link then the affiliate user will get the commission instantly. ",
    technology: "NEXT JS, NEST JS, Tailwind, Mongo DB, Java",
    duration: "5 Months",
    live: "https://affiliate.rokomari.io/",
    img: [
      "https://i.ibb.co/jrvSNpK/Screenshot-9.png",
      "https://i.ibb.co/pdwcf5Z/Screenshot-10.png",
      "https://i.ibb.co/TkgW4rh/banner1.jpg",
      "https://i.ibb.co/Q6dbgJn/Screenshot-7.png",
      "https://i.ibb.co/bPwLCtb/Screenshot-8.png",
      "https://i.ibb.co/TkgW4rh/banner1.jpg",
      "https://i.ibb.co/KhyLKyd/Screenshot-11.png",
      "https://i.ibb.co/6YsmTzR/Screenshot-12.png",
      "https://i.ibb.co/Q6dbgJn/Screenshot-7.png",
      "https://i.ibb.co/bPwLCtb/Screenshot-8.png",
    ],
    points: [
      "Real Time OTP verification while login and register.",
      "Conversion count instant whenever the sale is done affiliate user will get commission",
      "Affiliate can generate his custom link",
      "Affiliate can connect his facebook",
      "User can check filter the products based on commission and hot selling or price",
      "User can see real time report as well as with a custom date range",
      "User can contact via facebook messenger",
      "Affiliate user can share his link in any platform and this link will be valid for next 72 hours.",
      "Though this website is not connected with the mother website but through api call, all the order update and product update is being syncronized",
      "Admin can CRUD on product, order, user. He can ban any user",
      "Admin can see the overall report on total sale, total click and so on",
      "Finance man can dispatch the payment which are approved automatically",
      "Order become approved when the order delivered and completed the return period",
      "Super admin has all kinds of powers",
    ],
  },
  {
    id: 101,
    projectName: "Intellifriend",
    summary:
      "IntelliFriend started its journey in 2019 from Dhaka, Bangladesh, reaching the user's top most trusted partner on their route to success. IntelliFriend develops a unique and user-focused monitoring software that records user activity. PC, Mac, Chromebook, iPhone / iPad, Android phones, and tablets so users can measure and score their individual productivity. ",
    technology: "Angular, Typescript, Electron JS",
    duration: "8 Months",
    live: "https://www.intellifriend.com/",
    img: [
      "https://i.ibb.co/yNF1gsG/Screenshot-15.png",
      "https://i.ibb.co/XSD9CDy/Screenshot-13.png",
      "https://i.ibb.co/XSD9CDy/Screenshot-13.png",
      "https://i.ibb.co/yNF1gsG/Screenshot-15.png",
    ],
    points: [
      "Track your activity, whether it is productive or not. ",
      "Identify the user's behavior using AI, analyze them, prepare a report and direct them to the path of success.",
      "IntelliFriend helps you achieve your goal by comparing your activity with the ideal activity that should be done to achieve that success",
      "The personal activity should remain personal. We only reveal activity data, tracking, and reports to the specific user. No higher-order admin or employer will get the details report",
      "Audit the user activity and check the user's goal. Let the user know how well they are stepping to success or report them if they are distracted from the right track.",
      "Automate risk ditection and block unwanted behaviour. It uses smart rules and alerts to always keep user and organization safe and secure",
      "Track the users need and update accordingly",
    ],
  },
  {
    id: 3,
    projectName: "G.Chair",
    summary:
      "A gaming chair selling website with separate admin and user dashboard. Admin can add products, remove products, manage orders by changing status, make another person admin. User can view his/her cart can delete his orders or pay it. User has option to give review.",
    technology:
      "React JS, Node JS, Firebase, Express JS, Mongo DB, React Router v-6",
    duration: "4 Days",
    client: "https://github.com/razon1494/Gaming-Chair",
    server: "https://github.com/razon1494/Gaming-Chair-Server",
    live: "https://gamers-chair.web.app/home",
    img: [
      "https://i.ibb.co/rt5Wg34/Screenshot-86.png",
      "https://i.ibb.co/RDg3Dnr/Screenshot-87.png",
      "https://i.ibb.co/BZWMk7G/Screenshot-88.png",
      "https://i.ibb.co/72gGwYN/slider2.png",
      "https://i.ibb.co/VLRS0mF/Screenshot-94.png",
      "https://i.ibb.co/7RjGMNm/Screenshot-89.png",
      "https://i.ibb.co/nnNR7qY/Screenshot-90.png",
      "https://i.ibb.co/KqX7Dv0/Screenshot-91.png",
      "https://i.ibb.co/cDC9kFf/Screenshot-92.png",
      "https://i.ibb.co/M8X5HbD/Screenshot-93.png",
    ],
    points: [
      "On the landing page Home Page has an slider showing some energetic photos with qoutes.",
      "After the slider 6 of our most popular chair shown.",
      "We also have a section to contact us and get wholesale price.",
      "To access other options users must have to be logged in",
      "In the purchase page user can book his/her desired chair.",
      "User Dashboard user will see 3 different routes",
      "Customer can pay his/her bill in this segment",
      "Customer can See his/her own Orders in My Orders segment, he/she can also delete orders there.",
      "Customer can give a review us with rating in Review segment",
      "Admin Dashboard Admin will see all the orders in this route/section",
      "Admin can delete the order and change the status pending to shipped here.",
      "Admin can add a new chair product from this section.",
      "Admin can creat another admin by email",
      "Admin can delete any existing products here",
    ],
  },
  {
    id: 4,
    projectName: "SeaKers",
    summary:
      "A tour planner website with some special routes. User can view all tour packages, can book a packages. Confirm booking implemneted. User can delete his/her booked package. Most excitingly user can custom his own tour by adding new tour individually.",
    duration: "2 Days",
    technology: "React JS, Node JS, Firebase, Express JS, Mongo DB, HTML, CSS.",
    client: "https://github.com/razon1494/Seakers-Client",
    server: "https://github.com/razon1494/Seakers-Server",
    live: "https://free-run-travels.web.app/home",
    img: [
      "https://i.ibb.co/fvbrzXj/Screenshot-97.png",
      "https://i.ibb.co/Y048YCt/Screenshot-98.png",
      "https://i.ibb.co/6PwNMVv/Screenshot-99.png",
      "https://i.ibb.co/S5NTXN5/Screenshot-100.png",
      "https://i.ibb.co/yshR9nJ/slide1.png",
      "https://i.ibb.co/S5NTXN5/Screenshot-100.png",
      "https://i.ibb.co/dMH0DJm/Screenshot-101.png",
      "https://i.ibb.co/mv033S1/Screenshot-102.png",
      "https://i.ibb.co/7jRDGK4/Screenshot-95.png",
      "https://i.ibb.co/N1gxVVg/Screenshot-96.png",
    ],
    points: [
      "On the landing page Home Page has an slider showing some energetic photos with qoutes so that people encourged to go byond.",
      "After the slider All the tour packages listed",
      "We also show our regular offer or discount packages on home page to get marketing value.",
      "To access other options users must have to be logged in",
      "In this page we also branding our luxary trips below",
      "There is an arrow button to go another page for confirming the trip",
      "In the Admin Dashboard user will see all the orders from all users",
      "User can approve pending orders",
      "User also can delete the order",
      "In the Add Tour page user can custom or add a new tour",
      "Admin can add a new chair product from this section.",
    ],
  },
  {
    id: 5,
    projectName: "Cure & Care",
    summary:
      "A diagonestic center website. In this website user can login and order any diagonestic tests. There are private route to order the service. As well as some more routes like about us, appointment booking and join us segment has been implemented. Work is still under progress",
    duration: "2 Days",
    technology: "React JS, Node JS, Firebase, Express JS, Mongo DB, HTML, CSS.",
    client: "https://github.com/razon1494/care-cure",
    server: "https://github.com/razon1494/care-cure",
    live: "https://health-care-assignment-10.web.app/",
    img: [
      "https://i.ibb.co/2t2FvB8/Screenshot-108.png",
      "https://i.ibb.co/cQ4bbxx/Screenshot-103.png",

      "https://i.ibb.co/zGdLBLr/Screenshot-104.png",
      "https://i.ibb.co/GVs2GDW/slide3.png",
      "https://i.ibb.co/K6TtnbB/Screenshot-105.png",

      "https://i.ibb.co/PYHx0Gd/Screenshot-106.png",
      "https://i.ibb.co/Hz0cgfX/Screenshot-107.png",
    ],
    points: [
      "In this website user can sign up & login using thei email password or google account.",
      "in this website user can sign up & login using thei email password or google account.",
      "user can toggle login sign up.",
      "In the landing page you will get an overview of our institutions.",

      "At top all our address and contact information is given in home page.",
      "Then a menu bar with all routings.",
      "In the premimum courses page All of our services listed.",
      "You can see details by clicking the details button.",
      "There are two extra part one is for hiring ambulance and other is to contact us.",
      "In The about page you will know about the mission and visions of our organization.",
      "Steps are shown how to book a doctor appointment.",
      "Job advertisements are shown in this page.",
    ],
  },
];
const Projects = () => {
  return (
    <div className="container main-projects">
      <br />
      <h1 className="fw-bold my-5 projects-title">
        Here is some of my projects
      </h1>
      {projects.map((project) => (
        <ProjectCard2 tCard2 key={project.id} project={project}></ProjectCard2>
      ))}
    </div>
  );
};

export default Projects;
